<template>
	<div class="animated fadeIn">
		<div class="row">
			<div class="col-lg-12">
				<div class="card">
					<div class="card-header">Сокращатель ссылок</div>
					<div class="card-body">
						<div class="short-url">
						<b-form v-on:submit="createPretty" >
							<div class="form-row">
								<div class="form-group col-md-3">
									<div class="input-group mb-1 mr-sm-2">
										<div class="input-group-prepend">
											<div class="input-group-text">utm_source</div>
										</div>
										<b-form-select
											v-model="form.utm_source"
											@input = "address(form.address, form.utm_source, form.utm_medium, form.utm_campaign)"
										>
											<option  v-for="tableData in tableDatas.utm" :key="tableData.index" v-if="tableData.utm_type_id == 1" :value="'/?utm_source='+tableData.name">
												{{tableData.name}}</option>
										</b-form-select>
									</div>
								</div>
								<div class="form-group col-md-3">
									<div class="input-group mb-1 mr-sm-2">
										<div class="input-group-prepend">
											<div class="input-group-text">utm_medium</div>
										</div>
										<b-form-select
											v-model="form.utm_medium"
											@input = "address(form.address, form.utm_source, form.utm_medium, form.utm_campaign)"
										>
											<option  v-for="tableData in tableDatas.utm" :key="tableData.index" v-if="tableData.utm_type_id == 3" :value="'&utm_medium='+tableData.name">
												{{tableData.name}}</option>
										</b-form-select>
									</div>
								</div>
								<div class="form-group col-md-3">
									<div class="input-group mb-1 mr-sm-2">
										<div class="input-group-prepend">
											<div class="input-group-text">utm_campaign</div>
										</div>
										<b-form-input
											v-model="form.utm_campaign"
											@input = "address(form.address, form.utm_source, form.utm_medium, form.utm_campaign)"
										></b-form-input>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-md-3">
									<div class="input-group mb-1 mr-sm-2">
										<div class="input-group-prepend">
											<div class="input-group-text">Домен для сокращателя</div>
										</div>
										<b-form-select
											v-model="form.domain"
											:options=tableDatas.domain
											:value="null"
										></b-form-select>
									</div>
								</div>
								<div class="form-group col-md-6">
									<div class="input-group mb-1 mr-sm-2">
										<div class="input-group-prepend">
											<div class="input-group-text">Адрес без меток</div>
										</div>
										<b-form-input
											v-model="form.address"
											@input = "address(form.address, form.utm_source, form.utm_medium, form.utm_campaign)"
										></b-form-input>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-md-9">
									<div class="input-group mb-1 mr-sm-2">
										<div class="input-group-prepend">
											<div class="input-group-text">Адрес с метками</div>
										</div>
										<b-form-input
											v-model="form.long_url"
										></b-form-input>
									</div>
								</div>
							</div>
							<b-button type="submit" variant="primary">Сократить ссылку</b-button>
						</b-form>
						</div>
						<vuetable ref="vuetable"
											:fields="columns"
											:api-mode="false"
											:data="tableDatas"
											:css="css.table"
											@vuetable:pagination-data="onPaginationData">
						</vuetable>
						<vuetable-pagination ref="pagination"
												:css="css.pagination"
												@vuetable-pagination:change-page="onChangePage"
						></vuetable-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data () {
		return {
			form: [
				{
					domain: '',
					long_url: '',
					utm_source: '',
					utm_medium: '',
					utm_campaign: '',
					address: ''
				}
			],
			columns: [
				{
					name: 'url',
					title: 'Короткая ссылка'
				},
				{
					name: 'long_url',
					title: 'Оригинальная ссылка'
				},
				{
					name: 'date',
					title: 'Дата'
				}
			],
			tableDatas: [],
			createdId: [],
			css: {
				table: {
					tableClass: 'table table-striped table-bordered table-hovered table-responsive-sm',
					ascendingIcon: 'glyphicon glyphicon-chevron-up',
					descendingIcon: 'glyphicon glyphicon-chevron-down',
					handleIcon: 'glyphicon glyphicon-menu-hamburger'
				},
				pagination: {
					infoClass: 'pull-left',
					wrapperClass: 'vuetable-pagination pull-right',
					activeClass: 'btn-primary',
					disabledClass: 'disabled',
					pageClass: 'btn btn-border',
					linkClass: 'btn btn-border',
					icons: {
						first: '',
						prev: '',
						next: '',
						last: ''
					}
				}
			}
		}
	},
	created () {
		this.getPretty()
	},
	methods: {
		address (address, source, medium, campaign) {
			let utmcampaign = ''
			if (address === undefined) { address = '' }
			if (source === undefined) { source = '' }
			if (medium === undefined) { medium = '' }
			if (campaign !== undefined) { utmcampaign = '&utm_campaign=' + campaign }
			this.form.long_url = address + source + medium + utmcampaign
		},
		getPretty (page = 1) {
			this.$store.commit('CALL_API_ON')
			this.$http.get(this.$store.state.apiURL + '/v1/pretties?page=' + page, {}, {}).then(function (response) {
				this.tableDatas = response.body
				for (let key in this.tableDatas.data) {
					this.tableDatas.data[key].url = '<a href ="' + this.tableDatas.data[key].url + '" target=_blank>' + this.tableDatas.data[key].url + '</a>'
				}
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		},
		onPaginationData (paginationData) {
			this.$refs.pagination.setPaginationData(paginationData)
		},
		onChangePage (page) {
			this.getPretty(page)
			this.$refs.vuetable.changePage(page)
		},
		// Сокращаем ссылку
		createPretty () {
			let data = Object.assign({}, this.form)
			this.$store.commit('CALL_API_ON')
			this.$http.post(this.$store.state.apiURL + '/v1/pretties', data, {}).then(function (response) {
				this.tableDatas.data.unshift(response.body)
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		}
	}
}
</script>

<style>
	.short-url {
		margin: 20px
	}
</style>



// WEBPACK FOOTER //
// src/pages/pretty/index.vue